module.exports = "<my-railway-edit-form my-railway=\"$$railway.data.myRailway\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-railway-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/railway/templates/edit.html
// module id = 1518
// module chunks = 0